// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"3ce5fcd7dea332208c2b","678":"930a7652ecc1e0393e97","883":"9ee9e23703486b3ac9fb"}[chunkId] + ".js";
};